import type { NskResponse } from '~/models/Api';
import {
  deleteRequest,
  postRequest,
  putRequest
} from '~/utils/api/api_handler';

const paths = {
  create: '/deals/:deal_id/deal_estimation_headers',
  update: '/deals/:deal_id/deal_estimation_headers/:id',
  destroy: '/deals/:deal_id/deal_estimation_headers/:id',
  update_request: '/deals/:deal_id/deal_estimation_headers/:id/update_request',
  update_accept: '/deals/:deal_id/deal_estimation_headers/:id/update_accept',
  update_reject: '/deals/:deal_id/deal_estimation_headers/:id/update_reject'
};

export const create = async (
  dealId: number
): Promise<NskResponse<{ id: number }>> =>
  postRequest<{ id: number }, null>(
    paths.create.replace(':deal_id', String(dealId))
  );

export const update = async (
  dealId: number,
  dealEstimationHeaderId: number,
  status: 'reject' | 'cancel'
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    { status }
  );

export const destroy = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  deleteRequest(
    paths.destroy
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId))
  );

export const updateRequest = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_request
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );

export const updateAccept = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_accept
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );

export const updateReject = async (
  dealId: number,
  dealEstimationHeaderId: number
): Promise<NskResponse<void>> =>
  putRequest(
    paths.update_reject
      .replace(':deal_id', String(dealId))
      .replace(':id', String(dealEstimationHeaderId)),
    {}
  );
